export const agentTypes = [
  { option: 'CLIA', code: 'CLIA' },
  { option: 'TRUE', code: 'TRUE' },
  { option: 'IATA', code: 'IATA' },
  { option: 'TIDS', code: 'TIDS' },
  { option: 'OTHER', code: 'OTHER' },
];
